import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseTag } from '../components/base-tag/Component.js';

var defaultColors = {"filled":"tag__filled_v8k47"};
require('./default.desktop.css')

var styles = {"rectangular":"tag__rectangular_1k0ja","size-32":"tag__size-32_1k0ja","size-40":"tag__size-40_1k0ja","size-48":"tag__size-48_1k0ja","size-56":"tag__size-56_1k0ja","size-64":"tag__size-64_1k0ja","size-72":"tag__size-72_1k0ja"};
require('./desktop.css')

var invertedColors = {"filled":"tag__filled_1vc5w"};
require('./inverted.desktop.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var TagDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseTag, __assign({}, restProps, { colorStylesMap: colorStyles, ref: ref, styles: styles }))); });

export { TagDesktop };
